import { getPreviewImage } from 'pages/PreviewModel/utils';

const { VITE_API_DEV_HOST: apiDevHost } = process.env;

// Mirrors the server's createRpcID(): '21-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-00' with each X
// drawn from '0123456789ABCDEF'.
const RPC_GUID_PATTERN = /^21-([0-9A-F]{4}-){8}00$/;

// Legacy RPCs predate that generator and are shorter, with three alphanumeric groups rather than
// eight hex ones — e.g. '8-FU4H-WV80-8MU2-8'.
const LEGACY_RPC_GUID_PATTERN = /^[0-9A-Z]-([0-9A-Z]{4}-){3}[0-9A-Z]$/;

export const parseRpcGuid = fileName => {
  const name = (fileName || '').trim().replace(/(\.[^.\s]+)+$/, '').toUpperCase();
  const isGuid = RPC_GUID_PATTERN.test(name) || LEGACY_RPC_GUID_PATTERN.test(name);
  return isGuid ? name : null;
};

// Deliberately silent: this runs as a drop-time guess, so a miss falls back to the normal upload
// error rather than raising a message of its own.
export const resolveGuidPreview = async (guid, token) => {
  try {
    const options = { method: 'GET', headers: {} };

    if (token) {
      options.headers.Authorization = `Bearer ${token}`;
    }

    const res = await fetch(`${apiDevHost}/models/${guid}`, options);

    if (!res.ok) return null;

    const data = await res.json();
    const url = getPreviewImage(data, guid);

    if (!url) return null;

    return { url, name: data?.title || guid };
  } catch {
    return null;
  }
};
